import {
  CLOSE_HEADER_DROPDOWNS,
  SHOW_HEADER_DROPDOWN,
  TOGGLE_PEAKED,
  TOGGLE_SIDEBAR,
  UPDATE_VIEW_TYPE,
  VIDEO_DOWNLOADING,
  VIDEO_DOWNLOADING_PROGRESS,
  VIDEO_DOWNLOADING_RESET,
} from '../constants/actions';

export const closeDropdowns = () => {
  return { type: CLOSE_HEADER_DROPDOWNS };
};

export const showDropdown = name => {
  return {
    type: SHOW_HEADER_DROPDOWN,
    name,
  };
};

export const togglePeaked = () => {
  return { type: TOGGLE_PEAKED };
};

export const toggleSidebar = () => {
  return { type: TOGGLE_SIDEBAR };
};

export const updateViewType = isMobile => {
  return {
    type: UPDATE_VIEW_TYPE,
    is_mobile: isMobile,
  };
};

export const setDownloading = isDownloading => ({
  type: VIDEO_DOWNLOADING,
  isDownloading,
});
export const setDownloadingProgress = percent => ({
  type: VIDEO_DOWNLOADING_PROGRESS,
  percent,
});
export const resetDownloading = () => ({
  type: VIDEO_DOWNLOADING_RESET,
});
